import { Navigate, Route } from "react-router-dom";

import { IndexLayout } from "../layouts/index.layout";
import { exportRoute } from "./exportRoute";
import { renderRoutes } from "./renderRoutes";
import { appRoutes } from "./routerPaths";

export const getRoutes = ({ lang = "en", store = null }) => {
  return (
    <>
      <Route
        element={<IndexLayout />}
        // loader={args => {
        //   // Cookies.set("lang", args.params?.lang ?? lang, { expires: 7 });
        //   return null;
        // }}
      >
        {renderRoutes(appRoutes(), store)}
      </Route>

      <Route>{renderRoutes(exportRoute())}</Route>

      <Route
        path="*"
        element={
          <Navigate to={`/${lang === "en" ? "" : `${lang}/`}not-found`} />
        }
      />
    </>
  );
};
